import React from 'react'
import Grid from '@material-ui/core/Grid';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)


const SweetContent = ({imageUrl, message, idToSet= undefined, type='', textClass}) =>{

  const newId = idToSet? idToSet: `alert_content_${type}`

  return(
    <Grid item container id={newId} >
      <Grid item container justifyContent='center'>
        <Grid item >
          <img
            alt='icon'
            src={imageUrl}
            style={{height: '196px', width:'196px'}}
          />
        </Grid>
      </Grid>
      <Grid item container justifyContent='center' >
        <Grid item className={textClass? textClass : 'AlertMessageStyles'} >
          {message}
        </Grid>
      </Grid>
    </Grid>
  );
}

const BoardAlertHTML = ({title, text, idToSet= undefined, type=''}) =>{

  const newId = idToSet? idToSet: `alert_content_${type}`

  return(
    <Grid item container id={newId}>
      <Grid item container justifyContent='center' >
        <Grid item className='AlertMessageStyles2'>
          {title}
        </Grid>
        <Grid item className='alertText'>
          {text}
        </Grid>
      </Grid>
    </Grid>
  );
}

export const sweetAlert =(type, message, idToSet='', styles) => {
  const backgroundColor = (styles && styles.modalStyles && styles.modalStyles.backgroundColor)? styles.modalStyles.backgroundColor :  '#1F1F1F';
  const textClass = (styles && styles.messageClass )? styles.messageClass :  undefined;
  const background = `${backgroundColor} 0% 0% no-repeat padding-box`

    switch (type.toLowerCase()){
        case 'success':
          MySwal.fire({                
                background: background,
                html:<SweetContent
                  imageUrl='https://engage360.s3.amazonaws.com/Icons/Alerts/check-circle-regular.png'
                  message = {message}
                  idToSet={idToSet}
                  type={'success'}
                  textClass = {textClass}
                />,
                showConfirmButton: false,
                timer: 2000,
              })
            break;
        case 'error':
          MySwal.fire({
                background: background,
                html:<SweetContent
                  imageUrl='https://engage360.s3.amazonaws.com/Icons/Alerts/error-circle.png'
                  message = {message}
                  idToSet={idToSet}
                  type={'error'}
                  textClass = {textClass}
                />,
                showConfirmButton: false,
                timer: 2000
              })
            break;
        case 'warning':
          MySwal.fire({
                background: background,
                html:<SweetContent
                  imageUrl='https://engage360.s3.amazonaws.com/Icons/Alerts/warning-circle.png'
                  message = {message}
                  idToSet={idToSet}
                  type={'warning'}
                  textClass = {textClass}
                />,
                showConfirmButton: false,
                timer: 2000
              })
            break;
        default:
          MySwal.fire({
                background: background,
                html:<SweetContent
                  imageUrl='https://engage360.s3.amazonaws.com/Icons/Alerts/warning-circle.png'
                  message = {message}
                  idToSet={idToSet}
                  type={'default'}
                  textClass = {textClass}
                />,
                showConfirmButton: false,
                timer: 2000,                
              })
            
    }
}

export const SweetConfirmationAlert = async (title, idToSet) =>{

return  MySwal.fire(
    {
      html:<SweetContent
        imageUrl='https://engage360.s3.amazonaws.com/Icons/Alerts/warning-circle.png'
        message = {title}
        idToSet={idToSet}
        type={'dialog'}
      />,
      showDenyButton: true,
      showCloseButton: false,
      timer: 10000,
      customClass:'sweetAlertConfirm',
      confirmButtonText: `Yes`,
      denyButtonText:'No',
      didOpen:() =>{
        const okBtn = document.getElementsByClassName('swal2-confirm')

        if(okBtn && okBtn.length > 0){
          okBtn[0].setAttribute('id','alert_OkBtn');
        }

        const cancelBtn = document.getElementsByClassName('swal2-deny')

        if(cancelBtn && cancelBtn.length > 0){
          cancelBtn[0].setAttribute('id','alert_CancelBtn');
        }


      }
    })
}


export const BoardDeleteAlert = async (title, subtitle, idToSet) =>{

  return  MySwal.fire(
      {
        html:<BoardAlertHTML
          title={title}
          text={subtitle}
          idToSet={idToSet}
        />,
        showDenyButton: true,
        showCloseButton: false,
        timer: 10000,
        customClass:{
          popup:'sweetAlertConfirm2',
          confirmButton:'appbtn-engage redbtn-engage appbtnBarButton',
          denyButton:"appbtn-engage graybtn-engage appbtnBarButton"
        },
        buttonsStyling:false,
        confirmButtonText: `Delete`,
        denyButtonText:'Cancel',
        confirmButtonColor:'#C6344C',
        denyButtonColor:'#959494',

        reverseButtons:true,
        didOpen:() =>{
          const okBtn = document.getElementsByClassName('swal2-confirm')
  
          if(okBtn && okBtn.length > 0){
            okBtn[0].setAttribute('id','alert_OkBtn');
          }
  
          const cancelBtn = document.getElementsByClassName('swal2-deny')
  
          if(cancelBtn && cancelBtn.length > 0){
            cancelBtn[0].setAttribute('id','alert_CancelBtn');
          }
  
  
        }
      })
  }
  
